exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pan-upload-container{margin:15px;padding:15px;border:1px solid #eee;border-radius:10px;box-shadow:0 0.1rem 0.3rem rgba(0,0,0,0.15)}.center{text-align:center}\n", ""]);

